<template>
  <span class="mg-status" :class="status">
    <slot />
  </span>
</template>

<script>
  export default {
    name: 'mgStatus',
    props: {
      status: String,
    },
  }
</script>

<style lang="scss" scoped>
  span {
    line-height: 1;
    position: relative;
    font-weight: 600;
    margin-left: 12px;
    &::before {
      content: ' ';
      position: absolute;
      left: -12px;
      top: 50%;
      transform: translateY(-50%);
      width: 8px;
      height: 8px;
      border-radius: 50%;
    }
  }
</style>
